import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { getWindowForms } from "../../Forms/api";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Status buckets mirror WindowFormsAssignedDashboard — same statuses as the
// sales view but with ownership flipped (e.g. Approved means the quoter
// still has to record the order number, so it's "waiting on me" here).
const ACTION = ["Submitted", "Under Review", "Reviewing Revisions", "Approved"];
const WAITING = ["Needs Revision", "Awaiting Sales Approval"];
const DONE = ["Converted to Order"];

const AssignedWindowFormsWidget = () => {
  const user = useSelector(selectUser);
  const [forms, setForms] = useState(null);

  useEffect(() => {
    if (!user?.userID) return;
    getWindowForms(
      (data) => setForms(Array.isArray(data) ? data : []),
      null,
      user.userID
    );
  }, [user?.userID]);

  const count = (statuses) =>
    forms.filter((form) => statuses.includes(form.status)).length;

  return (
    <WidgetFrame title="Assigned Window Forms" to="/windowdoor/staff/windowforms">
      {forms ? (
        <div className="grid grid-cols-3 gap-2">
          <WidgetStat value={count(ACTION)} label="Waiting on me" />
          <WidgetStat value={count(WAITING)} label="With sales" />
          <WidgetStat value={count(DONE)} label="Ordered" />
        </div>
      ) : (
        <WidgetEmpty>Loading assigned forms…</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default AssignedWindowFormsWidget;
